<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
@import "style/css/bootstrap.css";
@import "style/css/reset.css";
@import "assets/font/iconfont.css";

body {
  margin: 0;
}
#app {
  /* font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  width: 12rem; */
  /* margin-top: 60px; no */
}
</style>
<style lang="less">
.el-pagination {
  li.number,
  button.btn-prev,
  button.btn-next,
  li.more {
    width: 40px; /*no*/
    height: 40px; /*no*/
    line-height: 40px; /*no*/
    background: rgba(255, 255, 255, 1) !important;
    border: 1px solid rgba(219, 219, 219, 1) !important;
    color: #666666;
    margin: 0 5px; /*no*/
    padding: 0;
    font-weight: 400;
    font-size: 13px;
    font-family: Microsoft YaHei;
    line-height: 40px; /*no*/
    &:hover {
      color: #ff6000 !important;
    }
  }
  li.number.active {
    background: #ff6000 !important;
    color: #fff;
    &:hover {
      color: #fff !important;
    }
  }
  button.btn-prev,
  button.btn-next {
    width: 80px; /*no*/
    span {
      display: block;
    }
    // display: flex;
    // align-content: center;
  }
}

@media (max-width: 539px) {
  .page-item {
    margin: 0 0.15rem;

    .page-link {
      padding: 0.25rem 0.625rem;
      border-radius: 0 !important;

      &:hover {
        color: #ff6000;
        background: #fff;
      }
    }
  }
  .page-item.disabled {
    .page-link {
      color: #dbdbdb;
    }
  }
}
@media (min-width: 540px) {
  .container {
    max-width: 1200px; /*no*/
    min-width: 1200px; /*no*/
    width: 1200px; /*no*/
    padding: 0 !important;
  }
  .nav-link {
    padding-left: 16px !important; /*no*/
    padding-right: 16px !important; /*no*/
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue